export default __webpack_public_path__ + "static/media/logo-app.6990717e.png";